<template>
  <div class="user-prof-str-base" :class="{affinity: this.targetNickname.length > 0}">
    <div class="user-prof">{{ userProfStr }}</div>
  </div>
</template>

<script>
export default {
  name: "userProfStr",
  props: {
    userName: {
      type: String,
      default() {
        return ''
      }
    },
    userBirthday: {
      type: String,
      default() {
        return ''
      }
    },
    targetNickname: {
      type: String,
      default() {
        return ''
      }
    }
  },
  computed: {
    userProfStr() {
      let y, m, d
      if(this.targetNickname != null && this.targetNickname.length > 0) {
        return `${this.userName}さんと${this.targetNickname}さんの相性`
      } else {
        [ y, m, d ] = this.userBirthday.split('-').map(item => parseInt(item))
        return `${ y }年${ m }月${ d }日生まれの${ this.userName }さん`
      }
    }
  }
}</script>

<style scoped lang="scss">
@import '../../../../../../sass/variables/index';
.user-prof-str-base {
  width: 100%;
  padding: 25px 0;
  .user-prof {
    width: 100%;
    padding: 14px 8px;
    color: $white;
    text-align: center;
    background: $brown-10;
    font-size: 12px;
    font-weight: bold;
    line-height: 1;
    @include mq('w320') {
      font-size: 14px;
    }
  }
  &.affinity {
    font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2020/partials/userProfStr.vue